import { gql } from 'graphql-request';
import { createQuery } from '@fivehealth/botero';

const GRAPHQL_DOCUMENT = gql`
  mutation cleoPatientDelete($input: DeleteCleoPatientInput!) {
    cleoPatientDelete(input: $input) {
      deleteMutationResult {
        uid
      }
    }
  }
`;

export default createQuery({
  gqlDocument: GRAPHQL_DOCUMENT,
  queryType: 'mutation',
  baseQueryKey: 'patientDischarge',
  keepPreviousData: true,
});
